export default __webpack_public_path__ + "static/1_31-55a01ab7def5dcf02567a8409493c326.png";